import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MenuOpen = function MenuOpen(props) {
  return /*#__PURE__*/ _jsxs(
    "svg",
    _extends(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
      },
      props,
      {
        children: [
          /*#__PURE__*/ _jsx("path", {
            fill: "transparent",
            fillOpacity: 0.01,
            d: "M8.33 3V22M20.98 18.5C20.95 19.3 20.87 19.83 20.65 20.27C20.35 20.87 19.86 21.35 19.27 21.65C18.59 22 17.71 22 15.93 22H7.07C5.3 22 4.41 22 3.73 21.65C3.13 21.35 2.65 20.86 2.35 20.27C2 19.59 2 18.71 2 16.93V8.07C2 6.3 2 5.41 2.35 4.73C2.65 4.13 3.14 3.65 3.73 3.35C4.41 3 5.29 3 7.07 3H15.94C17.71 3 18.6 3 19.28 3.35C19.88 3.65 20.36 4.14 20.66 4.73C20.76 4.92 20.82 5.12 20.87 5.36M12.61 12H22.39M22.39 12L18.39 8M22.39 12L18.39 16",
          }),
          /*#__PURE__*/ _jsx("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M8.33 3V22M20.98 18.5C20.95 19.3 20.87 19.83 20.65 20.27C20.35 20.87 19.86 21.35 19.27 21.65C18.59 22 17.71 22 15.93 22H7.07C5.3 22 4.41 22 3.73 21.65C3.13 21.35 2.65 20.86 2.35 20.27C2 19.59 2 18.71 2 16.93V8.07C2 6.3 2 5.41 2.35 4.73C2.65 4.13 3.14 3.65 3.73 3.35C4.41 3 5.29 3 7.07 3H15.94C17.71 3 18.6 3 19.28 3.35C19.88 3.65 20.36 4.14 20.66 4.73C20.76 4.92 20.82 5.12 20.87 5.36M12.61 12H22.39M22.39 12L18.39 8M22.39 12L18.39 16",
          }),
        ],
      }
    )
  );
};
export default MenuOpen;
